import { useEffect, useState } from 'react';

import { getLayers, getTimes, getUrl, _WXTilesLayer } from '@mono/wxtiles-service-api';

interface useWxtilesProps {
    wxtilesServiceUrl?: string;
    expandLayers: string[];
}

export const useWxtiles = ({ wxtilesServiceUrl = 'https://api.wxtiles.com', expandLayers }: useWxtilesProps) => {
    const [state, setState] = useState<{
        isLoadingLayers: boolean;
        layers: _WXTilesLayer[];
        expandedLayers: { layerId: string; times: string[] }[];
    }>({
        isLoadingLayers: false,
        layers: [],
        expandedLayers: [],
    });

    useEffect(() => {
        expandLayers.forEach(prepareLayer);
    }, [expandLayers.join(''), state.layers.map((l) => l.id).join('')]);

    const prepareLayer = async (layerId: string) => {
        const layer = state.layers.find((l) => l.id == layerId);
        if (!layer) return;
        if (state.expandedLayers.some((l) => l.layerId == layerId)) return;

        const instance = layer.instances[0];
        const times = await getTimes(wxtilesServiceUrl, layer.id, instance.id);

        setState((state) => ({
            ...state,
            expandedLayers: [...state.expandedLayers, { layerId, times }],
        }));
    };

    useEffect(() => {
        (async () => {
            const layers = await getLayers(wxtilesServiceUrl);
            setState((state) => ({
                ...state,
                isLoadingLayers: false,
                layers,
            }));
        })();
    }, []);

    return {
        getUrl: (layerId: string, targetTime: string, styleId: string) => {
            const layer = state.layers.find((l) => l.id === layerId);

            if (!layer) return null;

            const instance = layer.instances[0];
            return getUrl(wxtilesServiceUrl, layer.id, styleId, instance.id, targetTime);
        },
        layers: state.layers,
        expandedLayers: state.expandedLayers,
    };
};
